const APP_REQUEST_TIMEOUT_MS = 10_000;

export async function fetchAppRequest(
  input: string,
  init: RequestInit,
  timeoutMs = APP_REQUEST_TIMEOUT_MS,
): Promise<Response> {
  const controller = new AbortController();
  const abortFromCaller = () => controller.abort(init.signal?.reason);
  const timeout = globalThis.setTimeout(
    () => controller.abort(new Error("docs_app_request_timeout")),
    timeoutMs,
  );

  if (init.signal?.aborted) abortFromCaller();
  else init.signal?.addEventListener("abort", abortFromCaller, { once: true });

  try {
    return await globalThis.fetch(input, {
      ...init,
      signal: controller.signal,
    });
  } finally {
    globalThis.clearTimeout(timeout);
    init.signal?.removeEventListener("abort", abortFromCaller);
  }
}
